import { View } from '@amzn/stencil-react-components/layout';
import React from 'react';

export const IconHeading = ({ size = 16 }) => {
  return (
    <View height={size} width={size}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="#23756b" viewBox="0 0 448 512">
        <path d="M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z" />
      </svg>
    </View>
  );
};
